export const OFFER_ICON_FALLBACK = "generic";
export const OFFER_ICONS = [
    { key: "towels", label: { en: "Towels", sv: "Handdukar" } },
    { key: "bedding", label: { en: "Bedding", sv: "Sängkläder" } },
    { key: "toiletries", label: { en: "Toiletries", sv: "Hygienartiklar" } },
    { key: "coffee", label: { en: "Coffee", sv: "Kaffe" } },
    { key: "tea", label: { en: "Tea", sv: "Te" } },
    { key: "water", label: { en: "Water", sv: "Vatten" } },
    { key: "wine", label: { en: "Wine", sv: "Vin" } },
    { key: "food", label: { en: "Food", sv: "Mat" } },
    { key: "cleaning", label: { en: "Cleaning", sv: "Städning" } },
    { key: "ironing", label: { en: "Ironing", sv: "Strykning" } },
    { key: "luggage", label: { en: "Luggage", sv: "Bagage" } },
    {
        key: "late-checkout",
        label: { en: "Late checkout", sv: "Sen utcheckning" },
    },
    { key: "spa", label: { en: "Spa", sv: "Spa" } },
    { key: "gym", label: { en: "Gym", sv: "Gym" } },
    { key: "taxi", label: { en: "Taxi", sv: "Taxi" } },
    { key: "generic", label: { en: "Other", sv: "Övrigt" } },
];
export const OFFER_ICON_VIEWBOX = "0 0 24 24";
export const OFFER_ICON_GLYPHS = {
    towels: [
        { kind: "rect", x: 3, y: 6.5, width: 18, height: 11, rx: 2.2 },
        { kind: "path", d: "M9 6.5v11" },
        { kind: "path", d: "M3.6 9.6h4.8M3.6 14.4h4.8" },
        { kind: "path", d: "M12.4 9.6h5.4M12.4 12h5.4M12.4 14.4h5.4" },
    ],
    bedding: [
        { kind: "path", d: "M2.6 19V8.4" },
        { kind: "path", d: "M2.6 14.2h18.8V19" },
        {
            kind: "path",
            d: "M21.4 14.2v-2.6a2.4 2.4 0 0 0-2.4-2.4h-8.6v5",
        },
        { kind: "circle", cx: 6.6, cy: 11.4, r: 2 },
    ],
    toiletries: [
        {
            kind: "path",
            d: "M9.6 3.5h4.8v2.2c0 .7.3 1.3.9 1.7A4.4 4.4 0 0 1 17 11v7.4a2.1 2.1 0 0 1-2.1 2.1H9.1A2.1 2.1 0 0 1 7 18.4V11a4.4 4.4 0 0 1 1.7-3.6c.6-.4.9-1 .9-1.7V3.5z",
        },
        { kind: "path", d: "M7.4 13.4h9.2" },
    ],
    coffee: [
        {
            kind: "path",
            d: "M3.6 8.6h13.2v6a4.4 4.4 0 0 1-4.4 4.4H8a4.4 4.4 0 0 1-4.4-4.4v-6z",
        },
        { kind: "path", d: "M16.8 10.2h1.7a2.4 2.4 0 0 1 0 4.8h-1.7" },
        { kind: "path", d: "M7.4 3.2c.9 1 .9 1.9 0 2.9M11 3.2c.9 1 .9 1.9 0 2.9" },
        { kind: "path", d: "M2.6 21h15" },
    ],
    tea: [
        {
            kind: "path",
            d: "M4.4 9.4h10.8v5.8a4 4 0 0 1-4 4H8.4a4 4 0 0 1-4-4V9.4z",
        },
        { kind: "path", d: "M15.2 10.8h1.5a2.2 2.2 0 0 1 0 4.4h-1.5" },
        { kind: "path", d: "M9.8 9.4V6.6h4.4" },
        { kind: "rect", x: 14.2, y: 3.2, width: 4.4, height: 3.4, rx: 0.8 },
    ],
    water: [
        {
            kind: "path",
            d: "M12 2.8c0 0 6 6.2 6 10.1a6 6 0 1 1-12 0C6 9 12 2.8 12 2.8z",
        },
        { kind: "path", d: "M9 13.4a3 3 0 0 0 3 3" },
    ],
    wine: [
        { kind: "path", d: "M7.6 3h8.8v4a4.4 4.4 0 0 1-8.8 0V3z" },
        { kind: "path", d: "M7.8 7.4h8.4" },
        { kind: "path", d: "M12 11.4V19" },
        { kind: "path", d: "M8.4 19h7.2" },
    ],
    food: [
        { kind: "path", d: "M2.8 18.4h18.4" },
        { kind: "path", d: "M4.6 18.4a7.4 7.4 0 0 1 14.8 0" },
        { kind: "path", d: "M12 11V9.4" },
        { kind: "dot", cx: 12, cy: 8.2, r: 1.1 },
        {
            kind: "path",
            d: "M8.6 5.4c.8-.9.8-1.7 0-2.6M15.4 5.4c.8-.9.8-1.7 0-2.6",
        },
    ],
    cleaning: [
        {
            kind: "path",
            d: "M9.4 8.4h4.8a2.2 2.2 0 0 1 2.2 2.2v8.2a1.7 1.7 0 0 1-1.7 1.7H8.9a1.7 1.7 0 0 1-1.7-1.7v-8.2a2.2 2.2 0 0 1 2.2-2.2z",
        },
        { kind: "path", d: "M9.8 8.4V4.8h4" },
        { kind: "path", d: "M7.2 13h9.2" },
        { kind: "path", d: "M15.4 3.2h4M15.4 5.6h3M15.4 8h4" },
    ],
    ironing: [
        {
            kind: "path",
            d: "M2.8 15.6h18.4v2.2a1.4 1.4 0 0 1-1.4 1.4H4.2a1.4 1.4 0 0 1-1.4-1.4v-2.2z",
        },
        {
            kind: "path",
            d: "M4.6 15.6c0-4.1 3.2-6.8 7.6-6.8h4.4a4 4 0 0 1 4 4v2.8",
        },
        { kind: "path", d: "M9.4 5.4h6.2" },
    ],
    luggage: [
        { kind: "rect", x: 3.4, y: 7.4, width: 17.2, height: 11.6, rx: 2.2 },
        {
            kind: "path",
            d: "M8.6 7.4V5.2A1.4 1.4 0 0 1 10 3.8h4a1.4 1.4 0 0 1 1.4 1.4v2.2",
        },
        { kind: "path", d: "M8.6 19v1.6M15.4 19v1.6" },
        { kind: "path", d: "M12 10.4v5.6" },
    ],
    "late-checkout": [
        { kind: "circle", cx: 12, cy: 13, r: 7.6 },
        { kind: "path", d: "M12 8.4V13l3.4 2" },
        { kind: "path", d: "M4.6 5 6.9 3M19.4 5 17.1 3" },
    ],
    spa: [
        { kind: "path", d: "M12 20.4c-4.4 0-8-3.2-8-7.2 4.4 0 8 3.2 8 7.2z" },
        { kind: "path", d: "M12 20.4c4.4 0 8-3.2 8-7.2-4.4 0-8 3.2-8 7.2z" },
        {
            kind: "path",
            d: "M12 20.4c0-4.6 1.7-8.6 4-10.6-2.6-1.5-5.4-1.5-8 0 2.3 2 4 6 4 10.6z",
        },
    ],
    gym: [
        { kind: "path", d: "M6.6 8.2v7.6M17.4 8.2v7.6" },
        { kind: "path", d: "M3.8 10.2v3.6M20.2 10.2v3.6" },
        { kind: "path", d: "M6.6 12h10.8" },
    ],
    taxi: [
        {
            kind: "path",
            d: "M2.8 17.6h18.4v-3.8a2.2 2.2 0 0 0-1.5-2.1l-1.3-.4-1.7-3.4a2.2 2.2 0 0 0-2-1.2H9.3a2.2 2.2 0 0 0-2 1.2l-1.7 3.4-1.3.4a2.2 2.2 0 0 0-1.5 2.1v3.8z",
        },
        { kind: "path", d: "M4.6 17.6v1.6M19.4 17.6v1.6" },
        { kind: "dot", cx: 7, cy: 14.8, r: 0.9 },
        { kind: "dot", cx: 17, cy: 14.8, r: 0.9 },
        { kind: "rect", x: 9.4, y: 2.8, width: 5.2, height: 2.8, rx: 0.9 },
    ],
    generic: [
        {
            kind: "path",
            d: "M11.1 3.4h7.4a2 2 0 0 1 2 2v7.4a2 2 0 0 1-.6 1.4l-6.6 6.6a2 2 0 0 1-2.8 0l-7.2-7.2a2 2 0 0 1 0-2.8l6.6-6.6a2 2 0 0 1 1.2-.8z",
        },
        { kind: "dot", cx: 16, cy: 7.9, r: 1.2 },
    ],
};
const KNOWN = new Set(OFFER_ICONS.map((i) => i.key));
export function offerIconKey(raw) {
    const key = typeof raw === "string" ? raw.trim() : "";
    return KNOWN.has(key) ? key : OFFER_ICON_FALLBACK;
}
export function offerIconShapes(raw) {
    return OFFER_ICON_GLYPHS[offerIconKey(raw)];
}
export function offerIconLabel(key, locale = "en") {
    const def = OFFER_ICONS.find((i) => i.key === key);
    return def ? def.label[locale] : key;
}
